export default __webpack_public_path__ + "static/media/Margo.900fe9b3.jpeg";